import type { Domain } from '@/lib/domain-context';

/**
 * Clear the claims cache. Called on logout or session changes.
 */
export function clearClaimsCache(): void {
  // No-op: getClaims was removed as dead code. Kept for call-site compatibility.
}

/**
 * Get the appropriate post-login redirect path based on the current domain.
 */
export function getPostLoginRedirect(domain: Domain): string {
  switch (domain) {
    case 'admin':
      return '/admin/dashboard';
    case 'jdsimplified':
    case 'askjds':
    default:
      return '/dashboard';
  }
}
